import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_FHIRQuery, ModuleFE_FHIRResourceSubtype } from '../../../../../_entity.js';
import './Renderer_FHIRQueryHeader.scss';
export class Renderer_FHIRQueryHeader extends ComponentSync {
    __onFHIRQueriesUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.query?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ query: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.query?._id)
            state.query = ModuleFE_FHIRQuery.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'fhir-query-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'fhir-query-header__title', children: this.state.query?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const query = this.state.query;
        if (!query?.subtypeId)
            return;
        const subtype = ModuleFE_FHIRResourceSubtype.cache.unique(query.subtypeId);
        if (!subtype)
            return;
        return _jsxs("span", { className: 'fhir-query-header__sub-title', children: ["Subtype: ", subtype.label] });
    };
}
//# sourceMappingURL=Renderer_FHIRQueryHeader.js.map